<script lang="ts">
  // This css import is necessary to avoid style flickering when navigating through routes.
  // This is only needed here.
  import '../app.css';

  import ClientNotificationsBanner from '$lib/components/client-notifications-banner/ClientNotificationsBanner.svelte';
  import Toaster from '$lib/components/toaster/Toaster.svelte';
  import { hasActiveNotifications } from '$lib/stores/client-notifications.store';

  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();
</script>

{#if $hasActiveNotifications}
  <ClientNotificationsBanner />
{/if}

<Toaster />

{@render children?.()}
